/// <reference path="../../app.definition.ts" />


import { Util } from "@common/util";
import { Serializable } from "./Serializable";
import { User } from "./user";

export enum RoleTypeEnum {
    VIEWER = "VIEWER",
    ASSIGNOR = "ASSIGNOR",
    ASSIGNEE = "ASSIGNEE"
}
export class ServiceNote implements Serializable<ServiceNote> {

    id;
    serviceNoteId;
    assignedServiceId;
    label: String;
    title: String;
    assignor: User;
    serviceDate: any;
    createdAt: any;
    assignedFormId;
    serviceUsers: User[] = [];
    canShareServiceNote: boolean;
    editAfterSubmit: boolean;
    deleted: boolean;
    noteTypeId;

    // this will be used for casting JSON to object
    deserialize(input) {
        input.id && (this.id = input.id);
        input.serviceNoteId && (this.serviceNoteId = input.serviceNoteId);
        input.assignedServiceId && (this.assignedServiceId = input.assignedServiceId);
        input.label && (this.label = input.label);
        input.label && (this.title = input.label);
        input.serviceDate && (this.serviceDate = Util.getNonUTCDate(parseFloat(input.serviceDate)));
        input.createdAt && (this.createdAt = new Date(input.createdAt));
        input.assignedFormId && (this.assignedFormId = input.assignedFormId);
        input.noteTypeId && (this.noteTypeId = input.noteTypeId);
        this.canShareServiceNote = !!input.canShareServiceNote;
        this.editAfterSubmit = !!input.editAfterSubmit;
        this.deleted = !!input.deleted;

        for (var i = 0; !!input.serviceUsers && i < input.serviceUsers.length; i++) {
            this.serviceUsers.push(new User().deserialize(input.serviceUsers[i]));
            if (input.serviceUsers[i].serviceRole == RoleTypeEnum.ASSIGNOR) {
                this.assignor = new User().deserialize(input.serviceUsers[i]);
            }
        }
        return this;
    }

    constructor() {
        // The below data is test data
    }

}
